module.exports = __webpack_public_path__ + "static/media/db-lg.008833a3.png";